<span *ngIf="!error">
    <span ngbTooltip="Rechnungsstellender Stamm: {{von.name}}">{{von.id}}</span>-<span ngbTooltip="Rechnungsempfangender Stamm: {{an.name}}">{{an.id}}</span>-<span ngbTooltip="Event: {{event.titel}}">{{event.id}}</span>-<span ngbTooltip="Laufende Nummer">{{number}}</span>
</span>
<span *ngIf="error">Noch nicht vergeben</span>
